import { CustomInputsDto } from "../../quoteRequestLines/views/useCustomInputs";

export type AggregatedCustomInput = CustomInputsDto[number] & {
  relativeInput: CustomInputsDto[number] | null;
};

export const aggregateCustomInputs = (customInputs: CustomInputsDto): AggregatedCustomInput[] => {
  const aggregatedInputs: AggregatedCustomInput[] = [];

  customInputs.forEach((input) => {
    if (input.relativeTo) {
      return;
    }

    const relativeInput = customInputs.find((i) => i.relativeTo === input.key);

    if (relativeInput) {
      aggregatedInputs.push({
        ...input,
        relativeInput: relativeInput,
      });
    } else {
      aggregatedInputs.push({ ...input, relativeInput: null });
    }
  });

  return aggregatedInputs;
};
